import styled from 'styled-components'

const Container = styled.div`
  position: relative;
  ${props => props.fullWidth && 'width: 100%'};
`

export default Container
